export enum LatestHistoryAction {
  None = '',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  GoodsLoaded = 'GOODS_LOADED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
  Start = 'TRIP_STARTED',
}
